import { gql } from '@lcs/shared/api';

export const getTileSets = gql`
   fragment TileSetFields on TileSet {
      tileSetId
      name
      description
      designerDescription
      tileSetTypeConnection {
         items {
            tileSetTypeId
            tile {
               tileId
               description
               typeId
               isCustom
               canEditRefreshTime
            }
         }
      }
   }

   query GetTileSets($filters: String) {
      tileSetsConnection(filters: $filters) {
         items {
            ...TileSetFields
         }
      }
   }
`;
